import React, { type JSX, type MouseEventHandler } from "react";

import SupCoin from "../../../icons/Coin";
import { SupChip as Chip } from "../../../components/UI/Chip";

export interface TagProps {
  assetIcon?: string | JSX.Element;
  assetLabel: string;
  chainIcon?: string | JSX.Element;
  chainLabel?: string;
  border?: boolean;
  small?: boolean;
  className?: string;
  active?: boolean;
  inactive?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const SupTag = ({
  assetIcon = <SupCoin className="object-cover object-center w-auto h-full" />,
  assetLabel,
  chainIcon,
  chainLabel,
  border = false,
  small = false,
  ...restProps
}: TagProps) => <Chip icon={assetIcon} subIcon={chainIcon} label={assetLabel} subLabel={chainLabel} border={border} small={small} {...restProps} />;
